import { createContentStackAxios } from '../../utils/createAxios';

export const api = createContentStackAxios();
